import { Stack, useLocalSearchParams } from 'expo-router';
import { getParam } from 'features/signup/utils/signupUtils';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';

const V2aAgreementViewer = () => {
  const urlSearchParams = useLocalSearchParams();
  const pdfUrl = getParam(urlSearchParams, 'pdfUrl') as string;
  const headerTitle = getParam(urlSearchParams, 'headerTitle') as string;

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: headerTitle,
        }}
      />
      <PdfViewer url={pdfUrl} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
  },
});

export default V2aAgreementViewer;
